import React, { useEffect, useState } from "react"
import * as S from "./logos-slider.styles"
import { Swiper, SwiperSlide } from "swiper/react"
import { useMediaQuery, useTheme } from "@mui/material"

const LogosSlider = ({
                       items,
                       progressIndex,
                       setProgressIndex,
                       progressCircle,
                       logosSlider
                     }) => {
  //   const slider = useRef(null)
  const [lastVisible, setLastVisible] = useState(5)
  const handleSlider = index => {
    logosSlider.current.swiper.slideTo(index)
    setProgressIndex(index)
  }
  const theme = useTheme()
  const [slidesPerView, setSlidesPerView] = useState(6)
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
  const isTablet = useMediaQuery(theme.breakpoints.down("md"))
  useEffect(() => {
    if (isMobile) {
      setSlidesPerView(4)
      setLastVisible(3)
      return
    }
    if (isTablet) {
      setSlidesPerView(5)
      setLastVisible(4)
    }
  }, [isTablet, isTablet])

  return (
    <S.Wrapper>
      <Swiper
        slidesPerView={4}
        ref={logosSlider}
        breakpoints={{
          900: {
            slidesPerView: 6
          },
          600: {
            slidesPerView: 5
          }
        }}
        onSlideChangeTransitionStart={(swiper) => {
          const { realIndex } = swiper
          const lastVisible = Math.min((realIndex) + (slidesPerView - 1), items.length)
          setLastVisible(lastVisible)
        }}
      >
        {items.map(({ logo, description }, index) => (
          <SwiperSlide key={`${description}-${index}`}>
            <S.Circle onClick={() => handleSlider(index)}>
              <div className="autoplay-progress" slot="container-end">
                {index === progressIndex && (
                  <svg viewBox="0 0 48 48" ref={progressCircle}>
                    <circle cx="24" cy="24" r="20"></circle>
                  </svg>
                )}
                <S.LogoContainer>
                  <S.LogoSwiper img={logo} className={lastVisible === index && index < (items?.length - 1) && "last"} />
                </S.LogoContainer>
              </div>
            </S.Circle>
          </SwiperSlide>
        ))}
      </Swiper>
    </S.Wrapper>
  )
}

export default LogosSlider
